import { createContext } from 'react';
import { Config } from '../services';

export interface ConfigContextProps {
  config: Config;
}

export const ConfigContext = createContext<ConfigContextProps>({} as ConfigContextProps);
